import { ValidationErrors } from "@angular/forms";

export abstract class ErrorMessagesServiceBase {
    abstract getErrorMessage(errors: ValidationErrors, fieldName: string, customMessage?: string): string | null | unknown;
}